export default __webpack_public_path__ + "static/media/colleges.73b274cd.webp";